import { BaseService } from './base-service';

class AiService extends BaseService {
  /**
   * 获取汇总内容
   * @param {Object} data 请求参数
   * @param {number | string} data.entity 对象ID
   * @param {number} data.businessId 业务ID
   * @returns {Promise} 响应数据
   */
  getSummaryContent(data) {
    return this.request({
      method: 'get',
      url: `/v1/ai/summary`,
      params: data
    });
  }

  /**
   * 格式化富文本内容
   * @param {string} content 原始内容
   * @returns {Promise} 响应数据
   */
  format(content) {
    return this.request({
      method: 'post',
      url: `/v1/ai/summary/format`,
      data: {
        rawContent: content,
        aiConfigType: 'formatOrganization2'
      },
      params: { apiIndex: `${Math.random() * 100}` }
    });
  }

  /**
   * AI钱包充值重试
   * @param {Object} data 请求参数
   * @param {string} data.requestid 请求ID
   * @returns {Promise} 响应数据
   */
  retryAiWalletRecharge(data) {
    return this.request({
      method: 'post',
      url: `/ai-wallet/recharge`,
      data
    });
  }
}

export const aiService = new AiService();
